import axios from "axios";

import { Errors } from "./Errors";

import store from "../../store";

export class FormWithFiles {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   * @param {object} vuex
   */
  constructor(data, vuex) {
    this.originalData = data;
    if (vuex) {
      this.vuexEnabled = vuex.enabled;
      this.vuex = vuex;
    } else {
      this.vuexEnabled = false;
      this.vuex = null;
    }

    for (let field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let formData = new FormData();

    // FormData can not handle boolean values
    const transformAppendData = (value) => {
      if (typeof value === "boolean") {
        return value ? 1 : 0;
      }
      return value;
    };

    for (let property in this.originalData) {
      if (Array.isArray(this[property])) {
        //console.log('> ' + property + ' : ' + this[property].length + ' >');
        for (let i = 0; i < this[property].length; i++) {
          //console.log('>> data : ' + this[property][i] + ' >>');
          formData.append(
            property + "[]",
            transformAppendData(this[property][i])
          );
        }
      } else {
        //console.log('> ' + property + ' : ' + this[property] + ' >');
        formData.append(property, transformAppendData(this[property]));
      }
    }

    return formData;
  }

  /**
   * Reset the form fields.
   */
  reset(force) {
    if (force) {
      for (let field in this.originalData) {
        this[field] = "";
      }
    }

    this.errors.clear();
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   */
  post(url) {
    return this.submit("post", url);
  }

  test() {
    return this.data();
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   */
  submit(requestType, url) {
    //console.log(requestType, url);
    return new Promise((resolve, reject) => {
      axios[requestType](url, this.data(), {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.onSuccess(response.data);

          resolve(response.data);
        })
        .catch((error) => {
          this.onFail(error.response.data.errors);

          reject(error);
        });
    });
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess() {
    if (!this.vuexEnabled) {
      this.reset();
    }
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    if (this.vuexEnabled) {
      store.commit(this.vuex.actions.onFail, errors);
    } else {
      this.errors.record(errors);
    }
  }
}
